import { createApp } from 'vue';
import PageMenuVue from './page-menu.vue';
import { waitForBootstrap } from '../../bootstrap-helpers';

export class PageMenu {
    constructor(el, options) {
        this.props = options;
        this.init(el);
    }

    init(el) {
        const app = createApp(PageMenuVue, this.props);
        waitForBootstrap(() => app.mount(el));
    }
}